(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nuvo-legal-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.nvlm').forEach(function (root) {
      if (root.dataset.nvBound) return;
      root.dataset.nvBound = '1';

      var trigger = root.querySelector('[data-nvlm-trigger]');
      var overlay = root.querySelector('[data-nvlm-overlay]');

      /* El footer vive dentro de contenedores de Horizon (container
         queries / transform de las animaciones de scroll) que crean un
         "containing block" nuevo -- eso rompe "position: fixed" y deja
         el modal atrapado dentro del footer en vez de cubrir la
         pantalla completa (confirmado en vivo por Nicolás con capturas).
         Sacar el overlay al final de <body> es la forma robusta de
         arreglarlo sin tener que adivinar cuál ancestro es el culpable:
         así "fixed" siempre mide contra el viewport real. El botón se
         queda donde está, en el footer -- solo se mueve el overlay. */
      document.body.appendChild(overlay);

      var panels = overlay.querySelectorAll('[data-nvlm-panel]');
      var menu = overlay.querySelector('[data-nvlm-panel="menu"]');

      function showPanel(panel) {
        panels.forEach(function (p) { p.classList.remove('is-active'); p.hidden = true; });
        panel.hidden = false;
        panel.classList.add('is-active');
      }

      function open() {
        overlay.hidden = false;
        document.body.classList.add('nvlm-lock');
        showPanel(menu);
      }

      function close() {
        overlay.hidden = true;
        document.body.classList.remove('nvlm-lock');
      }

      trigger.addEventListener('click', open);

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) { close(); return; }
        if (e.target.closest('[data-nvlm-close]')) { close(); return; }
        if (e.target.closest('[data-nvlm-back]')) { showPanel(menu); return; }
        var showBtn = e.target.closest('[data-nvlm-show]');
        if (showBtn) {
          var handle = showBtn.getAttribute('data-nvlm-show');
          var target = overlay.querySelector('[data-nvlm-policy="' + handle + '"]');
          if (target) showPanel(target);
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !overlay.hidden) close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
